import {
    FETCH_BANK_ACCOUNTS, ADD_BANK_ACCOUNT, UPDATE_BANK_ACCOUNT,
    DELETE_BANK_ACCOUNTS, FETCH_STATEMENT_BANK_ACCOUNT, LOG_OUT_USER
} from "../../actions/actionTypes";

const fetchBankAccountsReducer = (bankAccounts, payload) => {
    let newBankAccounts = { ...bankAccounts };
    for(let acc of payload.bankAccounts){
        newBankAccounts[acc.accountId] = acc;
    }
    return newBankAccounts;
}

const addBankAccountReducer = (bankAccounts, payload) => {
    let newBankAccounts = {
        ...bankAccounts,
        [payload.bankAccount.accountId]: {...payload.bankAccount}
    };
    return newBankAccounts;
}

const updateBankAccountReducer = (bankAccounts, payload) => {
    let newBankAccounts = {
        ...bankAccounts,
        [payload.bankAccount.accountId]: {
            ...bankAccounts[payload.accountId],
            ...payload.bankAccount
        }
    };
    return newBankAccounts;
}

const deleteBankAccountsReducer = (bankAccounts, payload) => {
    let newBankAccounts = { ...bankAccounts};
    for(let accountId of payload.accountIds){
        delete newBankAccounts[accountId];
    }
    return newBankAccounts;
} 

const fetchStatementBankAccount = (bankAccounts, payload) => {
    return bankAccounts;
}


const bankAccountsReducer = (state={}, action) => {
    let bankAccounts = state;
    if (action && action.payload && !action.errors && !action.payload.errors){
        switch(action.type){
            case FETCH_BANK_ACCOUNTS:
                return fetchBankAccountsReducer(bankAccounts, action.payload);
            case ADD_BANK_ACCOUNT:
                return addBankAccountReducer(bankAccounts, action.payload);
            case UPDATE_BANK_ACCOUNT:
                return updateBankAccountReducer(bankAccounts, action.payload);
            case DELETE_BANK_ACCOUNTS:
                return deleteBankAccountsReducer(bankAccounts, action.payload);
            case FETCH_STATEMENT_BANK_ACCOUNT:
                return fetchStatementBankAccount(bankAccounts, action.payload);
            case LOG_OUT_USER:
                return {};
            default:
                return bankAccounts
        }
    }
    return bankAccounts;
}

export default bankAccountsReducer;